// All blog + lifestyle articles live in one array so a single ArticleDetail
// page can render any of them. "section" decides which listing page
// (Blog & News vs Fashion, Culture & Lifestyle) an article shows up on.

export const blogCategories = [
  "All",
  "Music News",
  "Interviews",
  "Industry",
  "Culture",
  "Partnerships",
  "Artist Spotlight"
];

export const lifestyleCategories = [
  "All",
  "Fashion",
  "Street Culture",
  "Entertainment",
  "Lifestyle",
  "Events",
  "Celebrity"
];

export const articles = [
  {
    slug: "amapianos-global-rise",
    section: "blog",
    tag: "Industry",
    title: "Amapiano's Global Rise: Inside the Sound That Won't Slow Down",
    excerpt:
      "What began as a regional sound out of townships near Pretoria has become one of the fastest-growing genres in the world.",
    author: "Amara Chukwu",
    authorRole: "Culture & fashion writer covering Lagos's creative scene.",
    authorAvatar: "https://picsum.photos/seed/mu-author-amara/80/80",
    date: "Jul 28, 2026",
    readTime: "6 min read",
    heroImage: "https://picsum.photos/seed/mu-article-amapiano/1200/500",
    content: [
      "Walk into any nightclub from Lagos to London this year, and there's a good chance the DJ will drop into a stretch of amapiano before the night is out. What began as a regional sound out of townships near Pretoria has become one of the fastest-growing genres in the world, and its trajectory shows no sign of slowing.",
      "The genre's signature — deep basslines, jazzy chords, and the unmistakable log drum — has proven remarkably adaptable. Producers from Lagos to Nairobi to Accra have folded amapiano's rhythmic DNA into their own regional sounds, creating hybrid tracks that top charts across multiple countries at once.",
      "Streaming data tells the story in numbers. Amapiano playlists have seen triple-digit growth on major platforms over the past two years, with listener bases expanding well beyond the African diaspora. International festivals have taken notice, carving out dedicated amapiano stages for the first time.",
      "For artists riding the wave, the challenge now is longevity — turning a viral moment into a lasting career. Labels and platforms alike are racing to build the infrastructure, from distribution to playlist relationships, that can support amapiano's next chapter."
    ]
  },
  {
    slug: "new-wave-lagos-fashion",
    section: "lifestyle",
    tag: "Street Culture",
    title: "The New Wave: Inside Lagos's Underground Fashion Scene",
    excerpt:
      "From thrifted Ankara remixes to genre-bending streetwear, a new generation of Lagos designers is rewriting what African fashion looks like.",
    author: "Amara Chukwu",
    authorRole: "Culture & fashion writer covering Lagos's creative scene.",
    authorAvatar: "https://picsum.photos/seed/mu-author-amara/80/80",
    date: "Jul 29, 2026",
    readTime: "6 min read",
    heroImage: "https://picsum.photos/seed/mu-article-lagos-fashion/1200/500",
    content: [
      "In a warehouse tucked behind a stretch of Lekki backstreets, a Saturday afternoon pop-up draws a line that spills onto the road before doors even open. Racks of upcycled Ankara jackets sit beside hand-painted denim, each piece one of a kind. This is the new face of Lagos fashion — less runway, more workshop.",
      "Where the last decade of Nigerian fashion chased global luxury codes, a younger generation of designers is turning inward, mining thrift markets, tailor archives, and everyday street style for inspiration. The result is a look that borrows as much from local mechanic villages as it does from international runways.",
      "Music has been central to the shift. Afrobeats and alté artists — many of whom design or co-sign these labels — wear the pieces on stage and in music videos, turning limited drops into cultural moments before they even hit racks.",
      "For the designers behind this movement, the goal isn't imitation of Western fashion capitals, but a distinctly Lagos vocabulary — loud, layered, and unapologetically local."
    ]
  },
  {
    slug: "in-conversation-afro-fusion",
    section: "blog",
    tag: "Interviews",
    title: "In Conversation: Rising Voices of Afro-Fusion",
    excerpt: "Three emerging artists talk influences, breakthroughs, and where the sound goes next.",
    author: "Chidi Obi",
    authorRole: "Staff writer covering interviews and artist spotlights.",
    authorAvatar: "https://picsum.photos/seed/mu-author-chidi/80/80",
    date: "Jul 30, 2026",
    readTime: "5 min read",
    heroImage: "https://picsum.photos/seed/mu-article-afrofusion/1200/500"
  },
  {
    slug: "musicuntamed-lagos-music-wire",
    section: "blog",
    tag: "Partnerships",
    title: "MusicUntamed Partners with Lagos Music Wire",
    excerpt: "A new collaboration bringing distribution and coverage to a new generation of festival artists.",
    author: "Editorial Team",
    authorRole: "MusicUntamed staff.",
    authorAvatar: "https://picsum.photos/seed/mu-author-editorial/80/80",
    date: "Jul 27, 2026",
    readTime: "3 min read",
    heroImage: "https://picsum.photos/seed/mu-article-partnership/1200/500"
  },
  {
    slug: "producers-shaping-afrobeats",
    section: "blog",
    tag: "Music News",
    title: "5 Producers Shaping the New Afrobeats Sound",
    excerpt: "The names behind the boards on this year's biggest records.",
    author: "Chidi Obi",
    authorRole: "Staff writer covering interviews and artist spotlights.",
    authorAvatar: "https://picsum.photos/seed/mu-author-chidi/80/80",
    date: "Jul 23, 2026",
    readTime: "4 min read",
    heroImage: "https://picsum.photos/seed/mu-article-producers/1200/500"
  },
  {
    slug: "streaming-numbers-african-artists",
    section: "blog",
    tag: "Industry",
    title: "How Streaming Numbers Are Changing for African Artists",
    excerpt: "What long-term streaming trends really mean for how artists earn and reach fans.",
    author: "Amara Chukwu",
    authorRole: "Culture & fashion writer covering Lagos's creative scene.",
    authorAvatar: "https://picsum.photos/seed/mu-author-amara/80/80",
    date: "Jul 22, 2026",
    readTime: "7 min read",
    heroImage: "https://picsum.photos/seed/mu-article-streaming/1200/500"
  },
  {
    slug: "behind-the-boards-studio-diary",
    section: "blog",
    tag: "Culture",
    title: "Behind the Boards: A Producer's Studio Diary",
    excerpt: "A week inside the sessions that built this summer's biggest single.",
    author: "Chidi Obi",
    authorRole: "Staff writer covering interviews and artist spotlights.",
    authorAvatar: "https://picsum.photos/seed/mu-author-chidi/80/80",
    date: "Jul 18, 2026",
    readTime: "4 min read",
    heroImage: "https://picsum.photos/seed/mu-article-studio/1200/500"
  },
  {
    slug: "business-of-playlist-placement",
    section: "blog",
    tag: "Industry",
    title: "The Business of Playlist Placement: What Artists Should Know",
    excerpt: "Everything artists should understand before their next pitch.",
    author: "Editorial Team",
    authorRole: "MusicUntamed staff.",
    authorAvatar: "https://picsum.photos/seed/mu-author-editorial/80/80",
    date: "Jul 18, 2026",
    readTime: "6 min read",
    heroImage: "https://picsum.photos/seed/mu-article-playlist/1200/500"
  },
  {
    slug: "independent-labels-redefining-african-music",
    section: "blog",
    tag: "Artist Spotlight",
    title: "Independent Labels Redefining African Music",
    excerpt: "The small teams building outsized influence across the continent.",
    author: "Amara Chukwu",
    authorRole: "Culture & fashion writer covering Lagos's creative scene.",
    authorAvatar: "https://picsum.photos/seed/mu-author-amara/80/80",
    date: "Jul 12, 2026",
    readTime: "5 min read",
    heroImage: "https://picsum.photos/seed/mu-article-labels/1200/500"
  },
  {
    slug: "chart-movers-this-month",
    section: "blog",
    tag: "Music News",
    title: "This Month's Biggest Chart Movers",
    excerpt: "A roundup of the tracks climbing fastest across the platform.",
    author: "Editorial Team",
    authorRole: "MusicUntamed staff.",
    authorAvatar: "https://picsum.photos/seed/mu-author-editorial/80/80",
    date: "Jul 8, 2026",
    readTime: "3 min read",
    heroImage: "https://picsum.photos/seed/mu-article-charts/1200/500"
  },
  {
    slug: "lagos-fashion-week-boldest-looks",
    section: "lifestyle",
    tag: "Fashion",
    title: "Lagos Fashion Week: The Boldest Looks of the Season",
    excerpt: "Standout runway moments and the designers pushing Nigerian fashion forward.",
    author: "Amara Chukwu",
    authorRole: "Culture & fashion writer covering Lagos's creative scene.",
    authorAvatar: "https://picsum.photos/seed/mu-author-amara/80/80",
    date: "Jul 26, 2026",
    readTime: "5 min read",
    heroImage: "https://picsum.photos/seed/mu-article-fashionweek/1200/500"
  },
  {
    slug: "amapiano-biggest-night-out",
    section: "lifestyle",
    tag: "Entertainment",
    title: "Inside Amapiano's Biggest Night Out",
    excerpt: "A look at how amapiano culture is showing up on dance floors far beyond South Africa.",
    author: "Chidi Obi",
    authorRole: "Staff writer covering interviews and artist spotlights.",
    authorAvatar: "https://picsum.photos/seed/mu-author-chidi/80/80",
    date: "Jul 24, 2026",
    readTime: "4 min read",
    heroImage: "https://picsum.photos/seed/mu-article-nightout/1200/500"
  },
  {
    slug: "wellness-rituals-nigerian-creatives",
    section: "lifestyle",
    tag: "Lifestyle",
    title: "5 Wellness Rituals Nigerian Creatives Swear By",
    excerpt: "How musicians, stylists, and creatives stay grounded between releases and shoots.",
    author: "Amara Chukwu",
    authorRole: "Culture & fashion writer covering Lagos's creative scene.",
    authorAvatar: "https://picsum.photos/seed/mu-author-amara/80/80",
    date: "Jul 21, 2026",
    readTime: "4 min read",
    heroImage: "https://picsum.photos/seed/mu-article-wellness/1200/500"
  },
  {
    slug: "amvca-red-carpet-highlights",
    section: "lifestyle",
    tag: "Events",
    title: "AMVCA 2026: Red Carpet Highlights",
    excerpt: "The looks, the moments, and the styling choices that stood out on the red carpet.",
    author: "Chidi Obi",
    authorRole: "Staff writer covering interviews and artist spotlights.",
    authorAvatar: "https://picsum.photos/seed/mu-author-chidi/80/80",
    date: "Jul 20, 2026",
    readTime: "5 min read",
    heroImage: "https://picsum.photos/seed/mu-article-amvca/1200/500"
  },
  {
    slug: "afrobeats-stars-shaping-global-fashion",
    section: "lifestyle",
    tag: "Celebrity",
    title: "How Afrobeats Stars Are Shaping Global Fashion",
    excerpt: "From runway front rows to brand campaigns, artists are becoming fashion tastemakers.",
    author: "Amara Chukwu",
    authorRole: "Culture & fashion writer covering Lagos's creative scene.",
    authorAvatar: "https://picsum.photos/seed/mu-author-amara/80/80",
    date: "Jul 19, 2026",
    readTime: "5 min read",
    heroImage: "https://picsum.photos/seed/mu-article-globalfashion/1200/500"
  },
  {
    slug: "rise-of-ankara-in-streetwear",
    section: "lifestyle",
    tag: "Fashion",
    title: "The Rise of Ankara in Streetwear",
    excerpt: "Traditional print meets streetwear silhouette in a growing design movement.",
    author: "Amara Chukwu",
    authorRole: "Culture & fashion writer covering Lagos's creative scene.",
    authorAvatar: "https://picsum.photos/seed/mu-author-amara/80/80",
    date: "Jul 17, 2026",
    readTime: "4 min read",
    heroImage: "https://picsum.photos/seed/mu-article-ankara/1200/500"
  },
  {
    slug: "day-in-the-life-lagos-stylist",
    section: "lifestyle",
    tag: "Lifestyle",
    title: "A Day in the Life of a Lagos Stylist",
    excerpt: "Behind the scenes of building looks for some of the industry's biggest names.",
    author: "Chidi Obi",
    authorRole: "Staff writer covering interviews and artist spotlights.",
    authorAvatar: "https://picsum.photos/seed/mu-author-chidi/80/80",
    date: "Jul 15, 2026",
    readTime: "4 min read",
    heroImage: "https://picsum.photos/seed/mu-article-stylist/1200/500"
  },
  {
    slug: "alte-culture-nigerian-identity",
    section: "lifestyle",
    tag: "Street Culture",
    title: "Alté Culture Is Redefining Nigerian Identity",
    excerpt: "How a subculture built on music and fashion became a movement of its own.",
    author: "Amara Chukwu",
    authorRole: "Culture & fashion writer covering Lagos's creative scene.",
    authorAvatar: "https://picsum.photos/seed/mu-author-amara/80/80",
    date: "Jul 14, 2026",
    readTime: "5 min read",
    heroImage: "https://picsum.photos/seed/mu-article-alte/1200/500"
  },
  {
    slug: "no-music-no-life-rave-scene",
    section: "lifestyle",
    tag: "Street Culture",
    title: "No Music, No Life: Inside Lagos's Rave Scene",
    excerpt: "Underground parties, sound systems, and the crowd that never wants the night to end.",
    author: "Chidi Obi",
    authorRole: "Staff writer covering interviews and artist spotlights.",
    authorAvatar: "https://picsum.photos/seed/mu-author-chidi/80/80",
    date: "Jul 13, 2026",
    readTime: "4 min read",
    heroImage: "https://picsum.photos/seed/mu-article-rave/1200/500"
  }
];

export function getArticleBySlug(slug) {
  return articles.find((a) => a.slug === slug);
}

export function getArticlesBySection(section) {
  return articles.filter((a) => a.section === section);
}

// Grabs a handful of related articles for the "More Stories" grid —
// same tag first, then just fills up to `count` from the same section.
export function getRelatedArticles(article, count = 3) {
  const sameSection = articles.filter((a) => a.slug !== article.slug && a.section === article.section);
  const sameTag = sameSection.filter((a) => a.tag === article.tag);
  const rest = sameSection.filter((a) => a.tag !== article.tag);
  return [...sameTag, ...rest].slice(0, count);
}
